//Workspace
export const SET_WORKSPACE_LOADER = 'SET_WORKSPACE_LOADER';
export const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE';

//Project
export const SET_PROJECT_LOADER = 'SET_PROJECT_LOADER';
export const SET_DISCUSSION_DATA = 'SET_DISCUSSION_DATA';
export const SET_PROJECT_ACTIVITY = 'SET_PROJECT_ACTIVITY';

//Customer
export const SET_CUSTOMER_LOADER = 'SET_CUSTOMER_LOADER';
export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST';
export const SET_CUSTOMER_DETAIL = 'SET_CUSTOMER_DETAIL';
export const UPDATE_CUSTOMER_DETAIL = 'UPDATE_CUSTOMER_DETAIL';
export const CLEAR_CUSTOMER_DETAIL = 'CLEAR_CUSTOMER_DETAIL';
export const SET_INDIVIDUAL_CUSTOMER_DETAIL = 'SET_INDIVIDUAL_CUSTOMER_DETAIL';
export const SET_CUSTOMER_PROJECT_DETAIL = 'SET_CUSTOMER_PROJECT_DETAIL';
export const SET_CUSTOMERS_INVOICE_LIST = 'SET_CUSTOMERS_INVOICE_LIST';
export const SET_CUSTOMERS_PROJECT_LIST = 'SET_CUSTOMERS_PROJECT_LIST';
export const SET_MEMBER_INPUT = 'SET_MEMBER_INPUT';
export const UPDATE_MEMBER_INPUT = 'UPDATE_MEMBER_INPUT';
export const CLEAR_MEMBER_INPUT = 'CLEAR_MEMBER_INPUT';
export const SET_CUSTOMER_MEMBERS = 'SET_CUSTOMER_MEMBERS';

//Setting
export const SET_SETTING_LOADER = 'SET_SETTING_LOADER';
export const UPDATE_THEME_MODE = 'UPDATE_THEME_MODE';
export const SET_SETTING_INTEGRATION = 'SET_SETTING_INTEGRATION';
export const SET_SUBSCRIPTION_LIST = 'SET_SUBSCRIPTION_LIST';
export const SET_INVOICE_SETTING = 'SET_INVOICE_SETTING';
export const SET_NOTIFICATIONS_SETTING_DETAIL = 'SET_NOTIFICATIONS_SETTING_DETAIL';
export const UPDATE_NOTIFICATIONS_SETTING_DETAIL = 'UPDATE_NOTIFICATIONS_SETTING_DETAIL';
export const CLEAR_NOTIFICATIONS_SETTING_DETAIL = 'CLEAR_NOTIFICATIONS_SETTING_DETAIL';
export const SET_THEME_TYPE = 'SET_THEME_TYPE';
//Task
export const SET_TASK_LOADER = 'SET_TASK_LOADER';
export const SET_OVERDUE_TASKS = 'SET_OVERDUE_TASKS';
export const SET_CREATE_TASK_INPUT = 'SET_CREATE_TASK_INPUT';
export const UPDATE_CREATE_TASK_INPUT = 'UPDATE_CREATE_TASK_INPUT';
export const CLEAR_CREATE_TASK_INPUT = 'CLEAR_CREATE_TASK_INPUT';
export const SET_IS_TASK_FILTER_OPEN = 'SET_IS_TASK_FILTER_OPEN';
export const SET_OTHER_TASK_LIST = 'SET_OTHER_TASK_LIST';

//Time tracking
export const SET_TIME_TRACKING_LOADER = 'SET_TIME_TRACKING_LOADER';
export const SET_TIME_LOG_DATA = 'SET_TIME_LOG_DATA';
export const SET_CURRENT_TIME_TRACKING = 'SET_CURRENT_TIME_TRACKING';
export const UPDATE_TASK_DETAILS = 'UPDATE_TASK_DETAILS';
export const CLEAR_CURRENT_TIME_TRACKING = 'CLEAR_CURRENT_TIME_TRACKING';
export const SET_TIME_ENTRY_INPUT = 'SET_TIME_ENTRY_INPUT';
export const UPDATE_TIME_ENTRY_INPUT = 'UPDATE_TIME_ENTRY_INPUT';
export const CLEAR_TIME_ENTRY_INPUT = 'CLEAR_TIME_ENTRY_INPUT';
export const SET_TIME_TRACKING_ACTIVITY = 'SET_TIME_TRACKING_ACTIVITY';
export const SET_LIST_DROPDOWN = 'SET_LIST_DROPDOWN';
export const UPDATE_LIST_DROPDOWN = 'UPDATE_LIST_DROPDOWN';
export const CLEAR_LIST_DROPDOWN = 'CLEAR_LIST_DROPDOWN';
export const SET_TIMRE_TRACKING_REPORT_DATA = 'SET_TIMRE_TRACKING_REPORT_DATA';
export const UPDATE_REPORT_FILTER = 'UPDATE_REPORT_FILTER';
export const SET_CURRENT_TRACKING_TIME = 'SET_CURRENT_TRACKING_TIME';
export const SET_MY_TIME_LOG_DATA = 'SET_MY_TIME_LOG_DATA';
export const SET_MY_TIME_LOG_FILTER = 'SET_MY_TIME_LOG_FILTER';

//Invoice
export const SET_INVOICE_LOADER = 'SET_INVOICE_LOADER';
export const SET_INVOICE_LIST = 'SET_INVOICE_LIST';
export const SET_FILTERED_INVOICE_LIST = 'SET_FILTERED_INVOICE_LIST';
export const SET_INVOICE_VIEW_DATA = 'SET_INVOICE_VIEW_DATA';
export const SET_INVOICE_ACTIVITY_DETAIL = 'SET_INVOICE_ACTIVITY_DETAIL';
export const SET_INVOICE_DETAIL = 'SET_INVOICE_DETAIL';
export const UPDATE_INVOICE_DETAIL = 'UPDATE_INVOICE_DETAIL';
export const CLEAR_INVOICE_DETAIL = 'CLEAR_INVOICE_DETAIL';
export const SET_INVOICE_LIST_FILTERED_WISE = 'SET_INVOICE_LIST_FILTERED_WISE';
export const SET_CUSTOMER_INVOICE_DATA = 'SET_CUSTOMER_INVOICE_DATA';
export const SET_CUTOMER_INVOICE_TIMEFRAMES = 'SET_CUTOMER_INVOICE_TIMEFRAMES';
export const SET_INVOICE_BILLABLE_HOURS_DETAIL = 'SET_INVOICE_BILLABLE_HOURS_DETAIL';
export const UPDATE_INVOICE_BILLABLE_HOURS_DETAIL = 'UPDATE_INVOICE_BILLABLE_HOURS_DETAIL';
export const UPDATE_BILLABLE_HOURS_TIME_ENTRY_DETAIL = 'UPDATE_BILLABLE_HOURS_TIME_ENTRY_DETAIL';
export const CLEAR_INVOICE_BILLABLE_HOURS_DETAIL = 'CLEAR_INVOICE_BILLABLE_HOURS_DETAIL';

//Report
export const SET_REPORT_LOADER = 'SET_REPORT_LOADER';
export const SET_REPORT_TASK_DETAILS = 'SET_REPORT_TASK_DETAILS';
export const SET_FILTERED_REPORT_TASK_DETAILS = 'SET_FILTERED_REPORT_TASK_DETAILS';
export const SET_PAYMENT_REPORT_DATA = 'SET_PAYMENT_REPORT_DATA';
export const SET_FILTERED_PAYMENT_REPORT_DATA = 'SET_FILTERED_PAYMENT_REPORT_DATA';
export const SET_FILTERED_INVOICE_REPORT_DATA = 'SET_FILTERED_INVOICE_REPORT_DATA';
export const SET_INVOICE_REPORT_DATA = 'SET_INVOICE_REPORT_DATA';
export const SET_TEAM_MEMBER_REPORT_DATA = 'SET_TEAM_MEMBER_REPORT_DATA';
export const SET_FILTERED_TEAM_MEMBER_REPORT_DATA = 'SET_FILTERED_TEAM_MEMBER_REPORT_DATA';

//Chat Message
export const SET_CHAT_MESSAGE_LOADER = 'SET_CHAT_MESSAGE_LOADER';
export const SET_CHAT_GROUPS = 'SET_CHAT_GROUPS';
export const SET_PIN_CHAT_GROUPS = 'SET_PIN_CHAT_GROUPS';
export const SET_UNPIN_CHAT_GROUPS = 'SET_UNPIN_CHAT_GROUPS';
export const SET_CURRENT_CHAT_GROUP = 'SET_CURRENT_CHAT_GROUP';
export const SET_CURRENT_CHAT_GROUP_NAME = 'SET_CURRENT_CHAT_GROUP_NAME';
export const UPDATE_CURRENT_CHAT_GROUP_NAME = 'UPDATE_CURRENT_CHAT_GROUP_NAME';
